export default __webpack_public_path__ + "e8e9a422506e7d976f9b7b16a8640c80.png";